import { RFIconProps } from "../types";

export default function ChangeSingleIcon(props: RFIconProps) {
	return (
		<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15.4532 2H5.54676C3.58794 2 2 3.44642 2 5.23067V15.7693C2 17.5536 3.58794 19 5.54676 19H15.4532C17.4121 19 19 17.5536 19 15.7693V5.23067C19 3.44642 17.4121 2 15.4532 2Z"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.23828 11.5919H15.247L12.4545 8.99996"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
